import constate from 'constate';

import { useTaskEditor } from './useTaskEditor';

export const [TaskEditorProvider, useTaskEditorContext] = constate(useTaskEditor);
